import React, { useEffect } from 'react';

const Communicator = () => {
    

    useEffect(() => {

        const receiveMessage = (event) => {   
            // Security check: validate origin
            const allowedOrigin = 'https://accept.authorize.net'; // Replace with Authorize.Net origin
            if (event.origin !== allowedOrigin) {
                // console.warn('Blocked message from unknown origin:', event.origin);
                return;
            }
    
            // Call the parent function (window.parent.parent.CommunicationHandler)
            if (event.data && typeof event.data === 'string' && event.data.includes("action")) {

                const parentStorage = window.parent.parent.sessionStorage;
                const qstr = {action:event.data, response:(event.response? event.response : "")};
                // console.log("this is the whole event communicator:", event.data, event.response);
                if(parentStorage)
                {
                    parentStorage.setItem("authorizeAction", JSON.stringify(qstr));
                    // console.log(`Data saved in parent sessionStorage: authorizeAction = ${qstr}`);
                }
            }
        };
        // Attach message listener
        window.addEventListener('message', receiveMessage);

        return () => {
            // Cleanup listener on component unmount
            window.removeEventListener('message', receiveMessage);
        };
    }, []); // Empty dependency array ensures this runs only once

    return null; // This component doesn't render anything visually
};

export default Communicator;